export function NoTranslation({ children }) {
	return children
}
NoTranslation.tag = 'content'
NoTranslation.translation = false
